<template>
  <base-header>
    <ConsoleMenu/>
    <div slot="right">
      <gallery-columns-dialog />
    </div>
  </base-header>
</template>

<script>
import GalleryColumnsDialog from '@/components/dialogs/GalleryColumnsDialog'
import BaseHeader from './AppHeader'
import ConsoleMenu from './ConsoleMenu'

export default {
  name: 'AppHeaderForRace',
  components: {
    BaseHeader,
    ConsoleMenu,
    GalleryColumnsDialog,
  },
};
</script>
